import axios from "axios";

export const BASE_URL = "https://d3vih6zb2nx9ew.cloudfront.net/api";
export const GAME_BASE_URL = "https://game.lootrix.live";

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "multipart/form-data" },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error("API error:", err?.response?.data || err.message);
    return Promise.reject(err);
  }
);

export const toFormData = (obj) => {
  const fd = new FormData();
  Object.entries(obj).forEach(([k, v]) => fd.append(k, v));
  return fd;
};

export const getGamesAPI = () =>
  api.post("/client_user_new.php?type=getgames", toFormData({ type: "getgames" }));

export const updateSessionAPI = (encryptedPlayerID) =>
  api.post("/client_user_new.php?type=update_session", toFormData({ player_id: encryptedPlayerID }));

export const getUserDetailsAPI = (encryptedPlayerID) =>
  api.post("/client_user_new.php?type=user_details", toFormData({ player_id: encryptedPlayerID }));

export default api;